import { Container, Grid, Stack } from '@mui/material';
import pluralize from 'pluralize';
import React from 'react';

import Folded2025Loader from '~components/business-owner/Folded2025/components/Folded2025Loader';
import { useFolded2025FeatureData } from '~components/business-owner/Folded2025/hooks/useFolded2025Data';

import styles from './Folded2025FeatureFacts.module.scss';

import FeatureFactsIcon from '../../assets/FeatureFacts_Icon.svg?react';
import FiveStarIcon from '../../assets/icons/5Star.svg?react';
import AssistIcon from '../../assets/icons/Chat.svg?react';
import EmailIcon from '../../assets/icons/Mail.svg?react';
import PhoneIcon from '../../assets/icons/Phone.svg?react';
import Folded2025Card from '../Folded2025Card';
import Folded2025Title from '../Folded2025Title';

const Folded2025FeatureFacts = (): JSX.Element => {
	const { data, isLoading } = useFolded2025FeatureData();

	const durationInHours = data?.assist?.totalDurationMilliseconds
		? Math.round(data.assist.totalDurationMilliseconds / 600000)
		: 0;

	const renderContents = () => {
		if (isLoading) {
			return <Folded2025Loader />;
		} else {
			return (
				<Grid container spacing={2}>
					{data?.accelerate?.metrics?.totalFiveStarReviews ? (
						<Grid item xs={12} md={6}>
							<Folded2025Card icon={<FiveStarIcon />}>
								<Folded2025Card.Value size="xxl">
									{data?.accelerate?.metrics?.totalFiveStarReviews}
								</Folded2025Card.Value>
								<Folded2025Card.Label>
									Total five star reviews in Review Management
								</Folded2025Card.Label>
							</Folded2025Card>
						</Grid>
					) : null}

					{data?.messenger?.metrics?.totalSentMessages ? (
						<Grid item xs={12} md={6}>
							<Folded2025Card icon={<AssistIcon />}>
								<Folded2025Card.Value size="xxl">
									{Number(
										data?.messenger?.metrics?.totalSentMessages,
									).toLocaleString()}
								</Folded2025Card.Value>
								<Folded2025Card.Label>
									Total messages sent
								</Folded2025Card.Label>
								<Folded2025Card.Label>
									{data?.messenger?.metrics?.totalSentMessagesByAssist}{' '}
									sent by Assist
								</Folded2025Card.Label>
							</Folded2025Card>
						</Grid>
					) : null}

					{data?.accelerate?.metrics?.totalCampaigns ? (
						<Grid item xs={12} md={6}>
							<Folded2025Card icon={<EmailIcon />}>
								<Folded2025Card.Value size="xxl">
									{data?.accelerate?.metrics?.totalCampaigns}
								</Folded2025Card.Value>
								<Folded2025Card.Label>
									Total campaigns sent through Accelerate
								</Folded2025Card.Label>
							</Folded2025Card>
						</Grid>
					) : null}

					{durationInHours ? (
						<Grid item xs={12} md={6}>
							<Folded2025Card icon={<PhoneIcon />}>
								<Folded2025Card.Value size="xxl">
									{durationInHours.toLocaleString()}{' '}
									{pluralize('hour', durationInHours)}
								</Folded2025Card.Value>
								<Folded2025Card.Label>
									Total time saved with Assist
								</Folded2025Card.Label>
								<Folded2025Card.Label>
									{data?.assist?.totalCalls} calls handled by Assist
								</Folded2025Card.Label>
							</Folded2025Card>
						</Grid>
					) : null}
				</Grid>
			);
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.leftDecoration} />
			<div className={styles.rightDecoration} />
			<div className={styles.topDecoration} />

			<Container disableGutters>
				<Folded2025Title icon={<FeatureFactsIcon />}>
					Feature Facts
				</Folded2025Title>
				{renderContents()}
			</Container>
		</div>
	);
};

export default Folded2025FeatureFacts;
